export const FETCH_START = 'ai/FETCH_START'
export const FETCH_SUCCESS = 'ai/FETCH_SUCCESS'
export const FETCH_FAILURE = 'ai/FETCH_FAILURE'

export const SELECT = 'ai/SELECT'
export const NEXT = 'ai/NEXT'
export const PREV = 'ai/PREV'
export const DESELECT = 'ai/DESELECT'

export const HOVER = 'ai/HOVER'
export const END_HOVER = 'ai/END_HOVER'
